import { io } from 'socket.io-client'
import { getAuthToken } from 'utils/auth'
import { getNewAccessToken } from 'utils/io/http/axios'
import store from 'redux-store'
import { requestApp, setScreenCreating } from 'ducks/apps'
import { NEW_SCREEN_MODAL, removeModal } from 'ducks/editor/modals'

// eslint-disable-next-line import/no-mutable-exports
export const AIAssistantSocketClient = io(
  process.env['REACT_APP_COLLECTIONS_AGENT_SOCKET_URL'],
  {
    autoConnect: false,
    reconnection: true,
    transports: ['websocket'],
    query: {
      token: getAuthToken(),
    },
  }
)

AIAssistantSocketClient.on('createScreenSuccess', ({ appId, screenId }) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  store.dispatch(requestApp(appId, screenId))
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  store.dispatch(setScreenCreating(false))
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  store.dispatch(removeModal(NEW_SCREEN_MODAL))
})

AIAssistantSocketClient.on('createScreenReject', ({ error }) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  store.dispatch(setScreenCreating(false))
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  store.dispatch(removeModal(NEW_SCREEN_MODAL))
})

export const reconnectWebsocket = async (callback: () => void) => {
  AIAssistantSocketClient.disconnect()

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  AIAssistantSocketClient.io.opts.query = {
    token: (await getNewAccessToken()) ?? getAuthToken(),
  }

  AIAssistantSocketClient.connect()

  callback()
}
